interface ManifestRecord {
  OrderLineId: string;
  SmartSendId: string;
  ProviderId: string;
  AccountId: string;
  ManifestId: string;
}

interface ExtendedOrderCacheType {
  refundOrderLineIds: { orderlineId: string; amount: number; status: string; created: Date }[];
  claimOrderLineIds: {
    id: string;
    orderlineId: string;
    status: 'Pending Documents' | 'Offer Made' | string;
  }[];
  supportOrderLineIds: {
    id: string;
    orderlineId: string;
    status: 'Pending Customer' | 'Pending Customer Warned' | string;
  }[];
  recentlyBookedSmartSendItems: string[];
  manifestedOrderLineIds: ManifestRecord[];
  preManifestedOrderLineIds: ManifestRecord[];
}

export const ExtendedOrderCache: ExtendedOrderCacheType = {
  refundOrderLineIds: [],
  claimOrderLineIds: [],
  supportOrderLineIds: [],
  recentlyBookedSmartSendItems: [],
  manifestedOrderLineIds: [],
  preManifestedOrderLineIds: []
};
